import { useLocation } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import routes from "routes";

function CabecalhoFaixa({ title, subtitle }) {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  return (
    <MDBox mt={{ xs: 2, md: 3.5 }} mb={2}>
      <Card sx={{ overflow: "visible" }}>
        <MDBox
          mx={2}
          mt={-2}
          py={1.25}
          px={2}
          variant="gradient"
          borderRadius="lg"
          sx={({ palette, functions }) => ({
            background: functions.linearGradient(palette.corbase1.main, palette.corbase1.focus),
            boxShadow: "none",
          })}
        >
          <MDTypography variant="h6" color="white">
            {title}
          </MDTypography>
        </MDBox>

        {subtitle && (
          <MDBox px={3} pt={1} pb={1}>
            <MDTypography variant="button" color="text">
              {subtitle}
            </MDTypography>
          </MDBox>
        )}
      </Card>
    </MDBox>
  );
}

function CabecalhoTradicional({ title, subtitle }) {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

  return (
    <MDBox mt={{ xs: 2, md: 3.5 }} mb={2}>
      <Card sx={{ overflow: "visible" }}>
        <MDBox px={3} pt={3} pb={1}>
          <MDTypography variant="h5" fontWeight="bold">
            {title}
          </MDTypography>

          {subtitle && (
            <MDTypography variant="button" color="text" sx={{ display: "block", mt: 0.5 }}>
              {subtitle}
            </MDTypography>
          )}

          <MDBox
            mt={2}
            sx={({ palette, functions }) => ({
              height: 4,
              width: "100%",
              borderRadius: 2,
              backgroundImage: functions.linearGradient(
                palette.corbase1.main,
                palette.corbase1.focus
              ),
            })}
          />
        </MDBox>
      </Card>
    </MDBox>
  );
}

function findRouteMeta(pathname) {
  const flat = [];
  (function walk(nodes) {
    nodes?.forEach((r) => {
      if (r?.route) flat.push(r);
      if (r?.collapse) walk(r.collapse);
    });
  })(routes);
  return (
    flat.find((r) => r.route === pathname) ||
    flat.find((r) => pathname.startsWith(r.route + "/")) ||
    {}
  );
}

export default function PageHeader({ title, subtitle }) {
  const [controller] = useMaterialUIController();
  const { headerType } = controller; // "cabecalho1" | "cabecalho2"
  const { pathname } = useLocation();

  const meta = findRouteMeta(pathname);
  const finalTitle = title ?? meta.headerTitle ?? meta.name ?? "";
  const finalSubtitle = subtitle ?? meta.subtitle ?? "";

  return headerType === "cabecalho2" ? (
    <CabecalhoTradicional title={finalTitle} subtitle={finalSubtitle} />
  ) : (
    <CabecalhoFaixa title={finalTitle} subtitle={finalSubtitle} />
  );
}
